import { createAction } from '@reduxjs/toolkit'

export const fetchPitaSettings = createAction('pitaPage/fetchPitaSettings')
export const updatePitaMax = createAction('pitaPage/updatePitaMax')
export const uploadPita = createAction('pitaPage/uploadPita')
